import { AutogenModelEdimonitorControl, AutogenRowEdimonitorControl } from "./autogen/AutogenModelEdimonitorControl";

export class ModelEdimonitorControl extends AutogenModelEdimonitorControl<RowEdimonitorControl> {
	constructor() {
		super(RowEdimonitorControl);
	}
}

export class RowEdimonitorControl extends AutogenRowEdimonitorControl {
}